import { Box, IconButton, Stack } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import LogChat from './LogChat'

export default function LogChatDetail({
  id,
  onClose,
}: {
  id: number
  onClose?: () => void
}) {
  return (
    <Stack
      className="LogChatDetail"
      sx={{
        padding: 2,
        flexGrow: 1,
        minHeight: 0,
        overflow: 'auto',
      }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
          marginBottom: 1,
        }}
      >
        <IconButton
          onClick={() => {
            if (onClose) { onClose() }
          }}
          aria-label="Schließen"
          sx={{ minWidth: 40, minHeight: 40 }}
        >
          <CloseIcon />
        </IconButton>
      </Stack>
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        {id > -1 && (
          <LogChat
            id={id}
            initDisplaySize="normalItems"
          />
        )}
      </Box>
    </Stack>
  )
}
